import Snippet from '../../components/Snippet';
import HeroImgDeskAndMobil from '../../components/ui/HeroImgDeskAndMobil';
import LinkButton from '../../components/ui/LinkButton';
import { hero_Summer, lead, link_company, link_private } from './summer-copy';

const Summer = () => {
  return (
    <main className="relative">
      <div>
        <HeroImgDeskAndMobil {...hero_Summer} />
      </div>
      <div className="w-full max-w-screen-kia mx-auto pl-2 pr-2">
        <div className="max-w-7xl mx-auto mb-4">
          <p className="text-center font-light text-[18px] sm:text-[20px] px-2 mt-[30px]">
            {lead}
          </p>
        </div>
        <div className="flex flex-col items-center gap-1  sm:gap-10 sm:flex-row sm:justify-center">
          <LinkButton {...link_private} />

          <LinkButton {...link_company} />

          <Snippet page="summer" />
        </div>
      </div>
    </main>
  );
};

export default Summer;